import React from 'react';
import Logo from '../images/TransparentLogo.png';
import { Container, Typography, Box, Grid, Link, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const leftBoxStyle = {
}
const containerStyle = {
  backgroundColor: 'transparent',
  width: '100%',
}

const headerStyle = {
  fontFamily: 'Yeseva One',
  fontWeight: '300',
  color: 'black',
  marginBottom: '3%',
};

const Footer = () => {
  return (
    <Container 
      component="footer" 
      sx={{
        ...containerStyle,
        overflowX: 'hidden', // Prevent horizontal scrolling
        padding: '1rem', // Add padding for better spacing
      }}
    >
      <Box 
        display="flex" 
        flexDirection="row" // Keep horizontal layout
        justifyContent="space-between" 
        alignItems="center" // Center align items vertically
        sx={{
          flexWrap: 'wrap', // Allow wrapping if needed
          textAlign: 'center', // Center text for all sections
          paddingX: { xs: '0.5rem', sm: '4rem' }, // Adjust padding for mobile and larger screens
          gap: { xs: '0.5rem', sm: '2rem' }, // Add spacing between sections
        }}
      >
        {/* Left Section (Contact and Follow Us) */}
        <Box 
          sx={{
            textAlign: 'center',
            flex: 1, // Allow this section to take up available space
          }}
        >
          <Typography 
            component="h4" 
            sx={{ 
              ...headerStyle, 
              fontSize: { xs: '1rem', sm: '1.5rem' }, // Shrink font size on mobile
            }}
          >
            Contact
          </Typography>
          <Typography sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
            Phone: 270-577-5067
          </Typography>
          <Box sx={{ marginTop: '0.5rem' }}>
            <Typography 
              component="h4" 
              sx={{ 
                ...headerStyle, 
                fontSize: { xs: '1rem', sm: '1.5rem' }, // Shrink font size on mobile
              }}
            >
              Follow Us
            </Typography>
            <Link 
              href="https://www.facebook.com/WildAtArtStudio.ky" 
              target="_blank" 
              rel="noopener noreferrer"
              sx={{ marginRight: '0.5rem' }}
            >
              <FacebookIcon fontSize="small" />
            </Link>
            <Link 
              href="https://www.instagram.com/wild_at_art_studio.ky" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <InstagramIcon fontSize="small" />
            </Link>
          </Box>
        </Box>

        {/* Center Section (Logo) */}
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          sx={{
            flex: 1, // Allow this section to take up available space
          }}
        >
          <img 
            src={Logo} 
            alt="Logo" 
            style={{ 
              width: '100px', // Shrink logo size on mobile
              maxWidth: '100%', 
            }} 
          />
        </Box>

        {/* Right Section (Wild At Art Address) */}
        <Box 
          sx={{
            textAlign: 'center',
            flex: 1, // Allow this section to take up available space
          }}
        >
          <Typography 
            component="h4" 
            sx={{ 
              ...headerStyle, 
              fontSize: { xs: '1rem', sm: '1.5rem' }, // Shrink font size on mobile
            }}
          >
            Wild At Art
          </Typography>
          <Typography sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
            112 N Main St.
          </Typography>
          <Typography sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
            Henderson, KY 42420
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Footer;